export const buttons ={
    "confirm": "Confirmar",
    "cancel": "Cancelar"
}
